module.exports = __webpack_public_path__ + "img/platinum.4ecee2b4.svg";